import { ChevronRight } from '@nexus/lib-react/dist/core/Icon/icons/default';
import { progressiveLoading } from '../../../../../commons/styles/animations';
import styled from '../../../../../theme/styled';

const Block = styled.div<{ showRedirectionStyles?: boolean }>`
  cursor: ${({ showRedirectionStyles }) => (showRedirectionStyles ? 'pointer' : 'auto')};

  // workaround for card nexus component
  // changing radius is not possible for all elements in the list card
  div[type='list'] {
    border-radius: 0;
  }

  div[type='list'] > div[type='list'] > div > p > a {
    &:empty {
      padding: 8px;
      margin: 5px 12px 0 0;

      ${progressiveLoading()}
    }
  }
`;

const ChevronIcon = styled(ChevronRight)`
  height: ${({ theme }) => theme.sizes[16]};
  width: ${({ theme }) => theme.sizes[16]};
`;

const Link = styled.a`
  text-decoration: none;
  color: inherit;
`;

export default {
  Block,
  Link,
  ChevronIcon,
};
